export default "__VITE_ASSET__DrS3ypx8__"